<template>
    <div class="remove-favorite">
        <h3>
            <v-icon>mdi-help-circle-outline</v-icon>{{ $TL.deleteFavorites }}
        </h3>
        <p>{{ $TL.sureToDeleteFavorites }}</p>
        <div class="operate-btm d-flex justify-content-end">
            <v-btn class="cancel-btn def" @click="cancel">{{
                $TL.cancel
            }}</v-btn>
            <v-btn
                class="agree-btn def gradient-bg"
                @click="remove_favorites"
                >{{ $TL.agree }}</v-btn
            >
        </div>
    </div>
</template>

<script>
import { removeFavorites } from "@/api/interface.js";
import { mapMutations, mapState } from "vuex";

export default {
    name: "remove-favorite",
    data() {
        return {};
    },
    computed: {
        ...mapState("favorites", ["favoritesId"])
    },
    methods: {
        ...mapMutations("favorites", ["updateFavoritesId"]),
        ...mapMutations("triggerEvtents", ["updateSnackbar"]),
        cancel() {
            this.$P.$emit("closeModal");
        },
        async remove_favorites() {
            await removeFavorites(this.favoritesId);
            this.$P.$emit("updateFavoritesData");
            this.updateSnackbar(this.$TL.deleteFavoritesSuccess);
            this.updateFavoritesId(null);
            this.cancel();
        }
    }
};
</script>
